import { hasClaimDetailValue } from './hasClaimDetailValue';

export const INITIAL_CLAIM_SUBMISSION_TITLE = 'Initial Claim Submission';

export const INITIAL_CLAIM_SUBMISSION_DISCLAIMER =
  'This is a read-only snapshot of the information provided when this claim was first submitted. It is not updated if payment or contact details change later.';

const PAYMENT_METHOD_LABELS = {
  echeck: 'E-Check',
  e_check: 'E-Check',
  physical_check: 'Physical Check',
  physicalcheck: 'Physical Check',
  ach: 'ACH',
};

export function formatClaimPaymentMethod(value) {
  if (!hasClaimDetailValue(value)) return null;
  const raw = String(value).trim();
  const key = raw.toLowerCase().replace(/\s+/g, '_');
  return PAYMENT_METHOD_LABELS[key] || raw;
}

export function formatClaimCheckAddress({
  street_check,
  city_check,
  state_check,
  check_zipcode,
  country_check,
} = {}) {
  const street = hasClaimDetailValue(street_check) ? String(street_check).trim() : '';
  const city = hasClaimDetailValue(city_check) ? String(city_check).trim() : '';
  const state = hasClaimDetailValue(state_check) ? String(state_check).trim() : '';
  const zip = hasClaimDetailValue(check_zipcode) ? String(check_zipcode).trim() : '';
  const country = hasClaimDetailValue(country_check) ? String(country_check).trim() : '';

  const cityStateZip = [city, [state, zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  const lines = [street, cityStateZip, country].filter(Boolean);
  return lines.length ? lines.join(', ') : null;
}
